import {
    NONE,
    RANDOMIZE,
    ACCUMULATE} from 'constants/aux-event-types.js';
import StepData from "pattern/StepData.js";

export const applyAuxEvents = (stepData, track) => {
    if (track.speedFactor !== 1) {
        stepData = copyStep(stepData);
        stepData.duration /= track.speedFactor;
    }

    if (!hasAuxEvents(track)) {
        return stepData;
    }

    // otherwise we need to apply the aux events
    stepData = copyStep(stepData);
    stepData = applyAuxEvent(stepData, stepData.auxEventAParameter, track.auxEventAType);
    stepData = applyAuxEvent(stepData, stepData.auxEventBParameter, track.auxEventBType);
    stepData = applyAuxEvent(stepData, stepData.auxEventCParameter, track.auxEventCType);
    stepData = applyAuxEvent(stepData, stepData.auxEventDParameter, track.auxEventDType);
    return stepData;
};

const hasAuxEvents = (track) => {
    return track.auxEventAType !== NONE ||
        track.auxEventBType !== NONE ||
        track.auxEventCType !== NONE ||
        track.auxEventDType !== NONE;
};

const applyAuxEvent = (stepData, auxEvent, auxEventType) => {
    if (auxEventType === NONE) {
        return stepData;
    }
    let auxEventValue = auxEvent.get();
    let track = stepData.track;
    let auxEventParameter = track.getAuxVariable(auxEvent.name);
    switch (auxEventType) {
    case RANDOMIZE:
        randomize(auxEventParameter, stepData, auxEventValue);
        break;
    case ACCUMULATE:
        accumulate(auxEventParameter, stepData, track, auxEventValue, auxEvent);
        break;
    }
    return stepData;
};

const randomize = (parameterName, stepData, auxEventValue) => {
    stepData[parameterName] += Math.random() * auxEventValue;
};

const accumulate = (parameterName, stepData, track, auxEventValue, auxEvent) => {
    if (track.accumulators[parameterName] === undefined) {
        track.accumulators[parameterName] = 0;
    }
    track.accumulators[parameterName] += auxEventValue;
    let limit = track.getAuxLimit(auxEvent.name);
    let mode = track.getAuxMode(auxEvent.name);
    if (accumulator(track, parameterName) > limit) {
        accumulator(track, parameterName, 0);
    }
    stepData[parameterName] += accumulator(track, parameterName);
}

const accumulator = (track, name, value) => {
    if (value !== undefined) {
        track.accumulators[name] = value;
        return undefined;
    }
    return track.accumulators[name];
}

const copyStep = (step) => {
    let stepToUse = new StepData(undefined, undefined, undefined, step.track);
    stepToUse.transpose = step.transpose;
    stepToUse.velocity = step.velocity;
    stepToUse.on = step.on;
    stepToUse.duration = step.duration;
    stepToUse.attack = step.attack;
    if (step.track.instrument) {
        stepToUse.release = null; 
    } else {
        stepToUse.release = step.release;
    }
    stepToUse.start = step.start;
    stepToUse.chop = step.chop;
    stepToUse.pitchAttack = step.pitchAttack;
    stepToUse.pitchSustain = step.pitchSustain;
    stepToUse.pitchRelease = step.pitchRelease;
    stepToUse.pitchDecay = step.pitchDecay;
    stepToUse.slice = step.slice;
    stepToUse.reverse = step.reverse;
    stepToUse.panning = step.panning;
    stepToUse.selectedRecording = step.selectedRecording;
    stepToUse.palette = step.palette;
    stepToUse.auxEventA = step.auxEventA;
    stepToUse.auxEventB = step.auxEventB;
    stepToUse.auxEventC = step.auxEventC;
    stepToUse.auxEventD = step.auxEventD;
    return stepToUse;
};
